module.exports = __webpack_public_path__ + "static/media/Commissioner-Regular.ef5c199c.ttf";